// Remove attachment functionality from trix
// Source: https://www.donnfelker.com/disable-attachments-in-the-trix-editor/

// Remove attachment button
document.addEventListener("trix-initialize", function (_event) {
  const fileTools = document.querySelector(".trix-button-group--file-tools");
  // sometimes thi is called twice so we guard against null elements
  fileTools?.remove();
});

// Remove paste ability
document.addEventListener("trix-attachment-add", function (event) {
  if (!event.attachment.file) {
    event.attachment.remove();
  }
});

// No-op file paste/drop events
document.addEventListener("trix-file-accept", function (event) {
  event.preventDefault();
});

// Let's not add mulitple h1s (or h2s) to a page
// Source: https://matthaliski.com/blog/customizing-the-trix-toolbar/
Trix.config.blockAttributes.heading1.tagName = "h3";
